import instance from "./axios";
import { CellType, CellPostPayload } from "../types/CellTypes";

export const fetchLastMaterialFoil = async (): Promise<CellType[]> => {
  const response = await instance.get<CellType[]>(
    "/v1.0/Material/GetLastMaterialCells?num=15"
  );
  return Array.isArray(response.data) ? response.data : [response.data];
};

export const postMaterialCell = async (payload: CellPostPayload) => {
  const res = await instance.post("/v1.0/Material/AddMaterialcell", payload);
  return res.data;
};

export const fetchCellLoader = async () => {
  try {
    const cells = await fetchLastMaterialFoil();
    return { title: "Cell", cells: cells ?? [] };
  } catch (error: any) {
    console.error(error.message || "Fehler beim Laden der Zell-Daten");
    throw new Response("Zell-Daten konnten nicht geladen werden", {
      status: 500,
    });
  }
};
